import { User } from 'lib-shared-types-api';
import { connect } from 'react-redux';

import { bindRtkActionToPromise } from 'app/utils/promiseActions';
import { AppDispatch, AppState } from 'bootstrap.store';
import { userModalActions } from 'components/usersModal';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { twilioActions } from '../../../app/middleware/twilio/actions/twilioActions';
import { websocketActions } from '../../../app/middleware/websocket/actions/websocket';
import { presenceActions } from '../../presence/actions/presenceActions';
import { actions as personalActions } from '../../settings/actions/personal';
import { transferToQueueActions } from '../../shared/transferToQueueModal/actions/transferToQueueModal';
import { teamActions } from '../actions/teamPage';
import { TeamList as TeamListImpl } from '../components/teamList';

const { teamToggleAgentDetails } = teamActions;
const { transferToQueueModalOpen } = transferToQueueActions;
const { presenceGet } = presenceActions;

const mapStateToProps = (state: AppState) => {
  return {
    profile: state.settings.profile.profile,
    appPresence: {
      asyncStatus: state.presence.meta.asyncStatus,
      items: state.presence.allPresence,
      item: state.presence.presence,
    },
    agentsDetail: state.team.agentsDetail,
    favouriteTeamMemberIds: state.settings.personal.favouriteTeamMemberIds,
    isMicrophoneBlocked: state.telephony.isMicrophoneBlocked,
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    wsRequest: bindRtkActionToPromise(dispatch, websocketActions.request),
    twilioMakeInternalCall: bindActionToPromise(
      dispatch,
      twilioActions.twilioMakeInternalCall,
    ),
    personalAddToFavouriteTeamMemberIds: bindActionToPromise(
      dispatch,
      personalActions.personalAddToFavouriteTeamMemberIds,
    ),
    personalRemoveFromFavouriteTeamMemberIds: bindActionToPromise(
      dispatch,
      personalActions.personalRemoveFromFavouriteTeamMemberIds,
    ),
    showUserModal: (user: Partial<User>) =>
      dispatch(userModalActions.show({ user })),
    transferToQueueModalOpen: (csid: number) =>
      dispatch(transferToQueueModalOpen({ csid })),
    toggleAgentDetails: (id: string) =>
      dispatch(teamToggleAgentDetails({ id })),
    getPresence: bindActionToPromise(dispatch, presenceGet),
  };
};

export type TeamListStateProps = ReturnType<typeof mapStateToProps>;
export type TeamListDispatchProps = ReturnType<typeof mapDispatchToProps>;

const TeamListConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TeamListImpl);

export { TeamListConnected as TeamList };
